module.exports = __webpack_public_path__ + "static/media/mood-calendar.ccf9d303.png";